import waselConstants from 'dashboard/constants/globals';
import waselAPI from './apiClient';

export const getTestimonialContent = () => {
  if (!waselConstants.TESTIMONIAL_URL) return Promise.resolve({ data: [] });

  return waselAPI.get(waselConstants.TESTIMONIAL_URL);
};
